import { Button } from '@progress/kendo-react-buttons';
import HierarchyButton from './Hierarchy/HierarchyButton';
import KBButton from './KB/KBButton';
import RelatedButton from './Related/RelatedButton';
import PrintButton from './Print/PrintButton';
import * as svg from '@progress/kendo-svg-icons';
import AssetButton from './Assets/AssetButton';
import WorkflowButton from './Workflow/WorkflowButton';
import { IUserProfile } from '../../../../../types/User/IUserProfile';
import { ITicketProps } from '../../../../../types/Ticket/ITicket';
import { Link } from 'react-router-dom';
import ActionFilterButton from './Filter/ActionFilterButton';
import { isMobile } from 'react-device-detect';
import SendEmailButton from './Email/SendEmailButton';
import MoveButton from './Move/MoveButton';
import SplitButton from './Move/SplitButton';
import Progress from '../../../../Gameplan/Progress';
import AddEventButton from './Event/AddEventButton';
import { IHostConfig } from '../../../../../types/Tenant/IHostConfig';

const Tools = (userProfile: IUserProfile, hostConfig: IHostConfig) =>
    [{
        id: 12,
        header: "Send Email",
        route: 'email',
        body: (ticket: ITicketProps) => <SendEmailButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: true,
        img: './images/toolbar/email.png',
        order: 0,
        docked: true
    }, {
        id: 15,
        header: "Close " + userProfile?.Phrases.CallPhrase,
        route: 'close',
        body: (ticket: ITicketProps) => null,
        resizable: false,
        className: 'tile',
        visible: isMobile,
        icon: 'minus-circle',
        docked: false
    }, {
        id: 7,
        header: "Hierarchy",
        route: 'parent-child',
        body: (ticket: ITicketProps) => <HierarchyButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: userProfile?.Features.Call_Hierarchy,
        img: './images/Toolbar/parent-child.png',
        order: 1,
        docked: true
    }, {
        id: 1,
        icon: 'toggle-full-screen-mode',
        header: "Asset",
        route: 'assets',
        body: (ticket: ITicketProps) => <AssetButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: !isMobile && userProfile?.Features.Asset_Manager,
        order: 2,
        docked: true
    }, {
        id: 8,
        header: "Filter",
        route: 'filter',
        body: (ticket: ITicketProps) => <ActionFilterButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: userProfile?.Features.Call_Action_Filter,
        img: './images/toolbar/filter.png',
        order: 4,
        docked: true
    }, {
        id: 10,
        header: "Event",
        route: 'event',
        body: (ticket: ITicketProps) => <AddEventButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: userProfile?.Features.Scheduled_Events,
        order: 5,
        docked: false,
        icon: 'calendar'
    }, {
        id: 11,
        header: "Apply Template",
        body: (ticket: ITicketProps) => <WorkflowButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: userProfile?.Features.Workflow,
        img: './images/Toolbar/workflow.png',
        order: 6,
        docked: false
    }, {
        id: 2,
        header: "Knowledge Base",
        route: 'kbase',
        body: (ticket: ITicketProps) => <KBButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: userProfile?.Features.KnowledgeBase,
        img: './images/Toolbar/kb.png',
        order: 7,
        docked: false
    }, {
        id: 4,
        header: "Merge",
        route: 'move',
        body: (ticket: ITicketProps) => <MoveButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: !isMobile && userProfile?.Features.Move_Split_Actions,
        img: './images/Toolbar/merge.png',
        order: 8,
        docked: false
    }, {
        id: 5,
        header: "Split",
        body: (ticket: ITicketProps) => <SplitButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: !isMobile && userProfile?.Features.Move_Split_Actions,
        img: './images/Toolbar/split.png',
        order: 9,
        docked: false
    }, {
        id: 6,
        header: "Print",
        route: 'print',
        body: (ticket: ITicketProps) => <PrintButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: hostConfig?.Print_Layout,
        icon: 'print',
        order: 10,
        docked: false
    }, {
        id: 13,
        header: "Share",
        route: 'share',
        body: (ticket: ITicketProps) => <Link to={`share`} title='Share'><Button disabled={ticket.Is_Loading} size='large' svgIcon={svg.shareIcon} className='off' ></Button></Link>,
        resizable: false,
        className: 'tile',
        visible: userProfile?.Features?.Tagging,
        icon: 'share',
        docked: false
    }
        , {
        id: 14,
        header: "Related " + userProfile?.Phrases.CallPhrase + "s",
        route: 'related',
        body: (ticket: ITicketProps) => <RelatedButton {...ticket} />,
        resizable: false,
        className: 'tile',
        visible: !isMobile,
        icon: 'clock-arrow-rotate',
        docked: false
    }
    ] as ITools[];

export default Tools;

export type ITools = {
    id: number,
    header: string,
    body: (ticket: ITicketProps) => JSX.Element,
    resizable?: boolean,
    className: string,
    visible: boolean,
    img?: string,
    icon?: string,
    order: number,
    route?: string,
    docked: boolean
}